export default __webpack_public_path__ + "img/marketIconMweb.3bb9f23d.svg";